// Reassurance links take shoppers straight to an open answer.
document.addEventListener('click', (event) => {
  const source = event.target instanceof Element ? event.target : event.target?.parentElement;
  const link = source?.closest('.dglp-confidence-links a[href^="#lp-"]');
  if (!link) return;
  const target = document.getElementById(link.getAttribute('href').slice(1));
  if (target instanceof HTMLDetailsElement) target.open = true;
});

// The existing concierge remains available whenever it has clear space.
// Hide only its launcher while it would cover landing-page content on mobile;
// the existing footer support button remains available throughout.
const initPaidConciergeClearance = () => {
  const root = document.querySelector('.dglp');
  const launcher = document.getElementById('diggn-chat-button');
  if (!root || !launcher) return;
  const footer = document.querySelector('footer');
  let frame = null;
  const update = () => {
    frame = null;
    if (window.innerWidth > 749 || launcher.getAttribute('aria-expanded') === 'true' || document.activeElement === launcher) {
      launcher.classList.remove('dglp-chat-obstructed');
      return;
    }
    const a = launcher.getBoundingClientRect();
    const blockers = Array.from(root.querySelectorAll('a, button, summary, h1, h2, h3, h4, p, li, figcaption, .dglp-price, .dglp-review-area'));
    if (footer) blockers.push(...footer.querySelectorAll('a, button, summary, h2, h3, p, li, dt, dd, small'));
    const overlaps = blockers.some((element) => {
      // Closed details can retain geometry for their hidden children.
      if (element.closest('details:not([open])') && !element.closest('summary')) return false;
      const b = element.getBoundingClientRect();
      return b.width > 0 && b.height > 0 && a.left < b.right && a.right > b.left && a.top < b.bottom && a.bottom > b.top;
    });
    launcher.classList.toggle('dglp-chat-obstructed', overlaps);
  };
  const schedule = () => { if (frame === null) frame = window.requestAnimationFrame(update); };
  window.addEventListener('scroll', schedule, { passive: true });
  window.addEventListener('resize', schedule, { passive: true });
  window.addEventListener('pageshow', schedule);
  window.addEventListener('load', schedule, { once: true });
  launcher.addEventListener('focus', schedule);
  launcher.addEventListener('blur', schedule);
  const changes = new MutationObserver(schedule);
  const observe = { subtree: true, childList: true, attributes: true, attributeFilter: ['hidden', 'open'] };
  changes.observe(root, observe);
  if (footer) changes.observe(footer, observe);
  if (typeof ResizeObserver !== 'undefined') {
    const resize = new ResizeObserver(schedule);
    resize.observe(root);
    if (footer) resize.observe(footer);
  }
  schedule();
};
if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', initPaidConciergeClearance, { once: true });
else initPaidConciergeClearance();
